import { defineStore } from "pinia";
import {v4 as uuidv4 } from "uuid"
import {reactive} from "vue"

const modalDialog = defineStore('modalDialog', 
{
    state: () => ({
        dialogItems: []
    }),
    actions: {
        /**
         * Create a new Dialog Item
         * @returns {Dialog} Dialog
         */
        addDialog() {
            const dialog = reactive(new Dialog());
            this.dialogItems.push(dialog)
            return dialog;
        },
        /**
         * 
         * @param {Dialog} item 
         */
        removeFlashMessage(item) {
            let index = this.dialogItems.findIndex(obj => obj.id == item.id)
            this.dialogItems.splice(index, 1);
        }
    },
    getters: {
/*         getDynamicClass: (state) => {
            return state.
        } */
    }

})

class Dialog {
    constructor() {
        this.message = ""
        this.id = uuidv4()
        this.thenFunction = () => {}
        this.cancelFunction = () => {}
        this.store = modalDialog()
        this.buttons = []
        this.inputFields = []
        this.cancelCaption = "Cancel"
        this.cancelBtnShow = true
        this.topic = ""
    }

    /**
     * 
     * @param {string} message HTML string | Write the message or content for the inner card body
     */
    setMessage(message) {
        this.message = message
    }

    /**
     * 
     * @param {string} topicText string | Topic value of card. Without no header will shown
     */
    setTopic(topicText) {
        this.topic = topicText
    }

    /**
     * 
     * @param {function} functionElement this function will trigger after a button has been clicked except for the cancel button.  
     */
    then(functionElement = () => {}) {
        this.thenFunction = functionElement
    }

    /**
     * 
     * @param {function} functionElement this function will trigger after the cancel button has been clicked except 
     */
    cancel(functionElement = () => {}) {
        this.cancelFunction = functionElement
    }

    /**
     * 
     * @param {string} text text / caption of Cancel button 
     */
    setCancelText(text) {
        this.cancelCaption = text
    }

    /**
     * you can hide the cancel button. 
     * TRUE => visiable
     * FALSE => hidden
     * @param {boolean} value Default is visible 
     */
    setCancelVisibilty(value) {
        this.cancelBtnShow = value
    }

    /**
     * If some Button loading return true
     * @returns {Boolean} 
     */
    isSomeButtonLoading() {
        for(let btn of this.buttons) {
            if(btn.isLoading) {
                return true
            }
        }
        return false
    }

    /**
     * Create a button to the footer of the dialog
     * @param {string} caption Text which is written on the button
     * @returns {Button}
     */
    addButton(caption="Okay") {
        const btn = new Button(this, caption);
        this.buttons.push(btn);
        return btn
    }

    /**
     * Add an input to the dialog
     * @param {string} type Choice the type "text", "number", "textarea"
     * @param {string} placeholder Which Placeholder do you want
     * @returns {InputField}
     */
    addInput(type="text", placeholder="") {
        const input = new InputField(this,type,placeholder);
        if(type == "select" && placeholder != "") {
            input.setValue(placeholder)
        }
        this.inputFields.push(input);
        return input
    }

    /**
     * Schließt bzw entfernt den Dialog. Alle Werte werden gelöscht
     */
    close() {
        let index = this.store.dialogItems.findIndex(obj => obj.id == this.id)
        this.store.dialogItems.splice(index, 1);
    }
}

class Button {
    constructor(parentDialog, caption) {
        this.parentDialog = parentDialog
        this.caption = caption
        this.id = uuidv4()
        this.isLoading = false
        this.callFunction = () => {}
        this.closeDialogAfterClick = true
        this.styleClass = "primary"
    }

    /**
     * 
     * @param {string} caption text or caption which is written on the button
     */
    setText(caption) {
        this.setCaption(caption)
    }

    /**
     * Function will run after button is clicked
     * @param {function} functionElement Function that is called when the button is clicked
     */
    then(functionElement) {
        this.callFunction = functionElement
    }

    /**
     * Specify what happens to the dialog when the button is clicked
     * @param {boolean} value TRUE = close | FALSE = let dialog open
     */
    setCloseDialogAfterClick(value) {
        this.closeDialogAfterClick = value
    }

    /**
     * set the style of the button 
     * @param {string} styleClass e.g. "outline-primary" | "secondary" | "secondary btn-sm"
     */
    setStyle(styleClass = "primary") {
        this.styleClass = styleClass
    }

    /**
     * Set btn to loading btn
     * @param {boolean} value 
     */
    setLoading(value) {
        this.isLoading = value
    }

    /**
     * Trigger the registered function
     */
    run() {
        this.callFunction();
        if(this.closeDialogAfterClick === true) {
            this.parentDialog.close()
        }
    }
}

class InputField {
    constructor(parentDialog, type = "text", placeholder="") {
        this.id = uuidv4();
        this.parentDialog = parentDialog
        this.options = [] // Options for HTML Select
        this.type = type
        this.value = null
        this.placeholder = placeholder
        this.labelText = ''
        this.mandatory = false
        this.error = false
    }

    /**
     * Overwrite the Value
     * You can use ref() for v-model
     * @param {*} value 
     */
    setValue(value) {
        this.value = value
    }

    /**
     * Setzt das Inputfeld als Pflichfeld
     * @param {boolean} value
     */
    setMandatory(value = true) {
        this.mandatory = value
    }

    setLabelText(text) {
        this.labelText = text
    }

    /**
     * Add an option for select
     * @param {*} name reference or string for option name
     * @param {*} value option value
     * @param {*} isSelected is this option selected
     * @param {*} isEnabled is this option enabled
     */
    addOption(name, value, isSelected = false, isEnabled = true) {
            const option = {
                id: uuidv4(),
                name: name,
                value: value,
                isSelected: isSelected,
                isEnabled: isEnabled
            }
            this.options.push(option)
        }

    /**
     * Set Input as error e.g. if missing a value
     */
    setError(value = true) {
        this.error = value
    }

    

}

export {modalDialog};